import { v4 as uuid } from "uuid";

export const videos = [
  {
    _id: "I5pVVmcSXVU",
    title: "Akaash Singh's Defense of Apu",
    thumbnail: "/assets/video-thumbnails/akash-singh-apu.jpg",
    category: "podcast",
    channel: "PowerfulJRE",
    channelAvatar: "/assets/channel-avatar/joe-rogan.jpg",
    date: "Feb 9, 2022",
    embedLink: "https://www.youtube.com/embed/I5pVVmcSXVU",
    id: "1",
  },
  {
    _id: "rFY2sjbrCEk",
    title: "LET'S GO. // Episode 4: Act II Kickoff - VALORANT",
    thumbnail: "/assets/video-thumbnails/yoru-valorant.jpg",
    category: "gaming",
    channel: "VALORANT",
    channelAvatar: "/assets/channel-avatar/valorant.jpg",
    date: "Mar 1, 2022",
    embedLink: "https://www.youtube.com/embed/rFY2sjbrCEk",
    id: "2",
  },
  {
    _id: "OfS1jFck8YQ",
    title: "INNA - Nirvana",
    thumbnail: "/assets/video-thumbnails/nirvana-inna.jpg",
    category: "music",
    channel: "INNA",
    channelAvatar: "/assets/channel-avatar/inna.jpg",
    date: "Nov 28, 2017",
    embedLink: "https://www.youtube.com/embed/OfS1jFck8YQ",
    id: "3",
  },
  {
    _id: "wvhP1al3Ur4",
    title: "Mac Studio Review: Double Trouble!",
    thumbnail: "/assets/video-thumbnails/mac-studio-marques-brownlee.jpg",
    category: "tech",
    channel: "Marques Brownlee",
    channelAvatar: "/assets/channel-avatar/marques-brownlee.jpg",
    date: "Mar 19, 2022",
    embedLink: "https://www.youtube.com/embed/wvhP1al3Ur4",
    id: "4",
  },
  {
    _id: "Qmi-Xwq-MEc",
    title: "Traveling to the Happiest Country in the World!!",
    thumbnail:
      "/assets/video-thumbnails/travelling-to-happiest-country-yes-theory.jpg",
    category: "vlog",
    channel: "Yes Theory",
    channelAvatar: "/assets/channel-avatar/yes-theory.jpg",
    date: "Dec 1, 2019",
    embedLink: "https://www.youtube.com/embed/Qmi-Xwq-MEc",
    id: "5",
  },
  {
    _id: "QtMzV73NAgk",
    title: "PlayStation 5 Unboxing & Accessories!",
    thumbnail: "/assets/video-thumbnails/marquees-ps5.jpg",
    category: "tech",
    channel: "Marques Brownlee",
    channelAvatar: "/assets/channel-avatar/marques-brownlee.jpg",
    date: "Oct 27, 2020",
    embedLink: "https://www.youtube.com/embed/QtMzV73NAgk",
    id: "6",
  },
  {
    _id: "9J5DxyPSwI4",
    title: "VALORANT | Raze - Only good things!",
    thumbnail: "/assets/video-thumbnails/raze-valorant.jpg",
    category: "gaming",
    channel: "VALORANT",
    channelAvatar: "/assets/channel-avatar/valorant.jpg",
    date: "Feb 25, 2022",
    embedLink: "https://www.youtube.com/embed/9J5DxyPSwI4",
    id: "7",
  },
  {
    _id: "3qHkcs3kG44",
    title: "Joe Rogan Experience #1309 - Naval Ravikant",
    thumbnail: "/assets/video-thumbnails/joe-rogan-naval.jpg",
    category: "podcast",
    channel: "PowerfulJRE",
    channelAvatar: "/assets/channel-avatar/joe-rogan.jpg",
    date: "Jun 5, 2019",
    embedLink: "https://www.youtube.com/embed/3qHkcs3kG44",
    id: "8",
  },
];
